import { TFunction } from 'i18next';
import { IPrivilegeOptionItem } from '@legacy/apis/reportingWidgetsAPI/types/addedValuePerMonth';
import { translationAnyText } from '@legacy/utils/translation';
export const convertPrivilegeOptionsToFilterOptions = (
  options: IPrivilegeOptionItem[],
  t: TFunction,
) =>
  options.map((option) => ({
    value: option.filterId,
    label: translationAnyText(t, `Filter${option.name}`),
  }));
